import { useTranslation } from 'react-i18next';

export default function FooterPageForm() {
    // hooks
    const { t } = useTranslation('translation', { keyPrefix: 'footer' });

    const currentYear = (new Date()).getFullYear();

    return (
        <footer className='w-full'>
            <div className='container'>
                <div className='text-[0.875em] leading-[1] text-center pt-2.5 pb-5'>
                    {t('copy_right', {
                        currentYear: currentYear ? ` - ${currentYear}` : ''
                    })}
                </div>
            </div>
        </footer>
    );
}
